<div>
    <h1 style="font-size: 15px; font-weight: bold; letter-spacing: 0.5px; margin: 0; padding: 0;">S3 Storage Explorer
    </h1>
    <p style="font-size: 12px; color: #555; margin: 0; padding: 0">Enter a bucket and prefix to inspect object storage
        classes, sizes, and folder hierarchy. Use this to find archival candidates and estimate potential savings.
    </p>

    <nz-divider style="margin: 10px 0px; padding: 0px" />

    <form nz-form nzLayout="inline" nzVariant="filled" [formGroup]="prefixForm" (ngSubmit)="onSubmitHandler()">
        <nz-form-item style="flex: 1;">
            <nz-form-label nzRequired>Bucket</nz-form-label>
            <nz-form-control nzErrorTip="Bucket is a required field" [nzExtra]="bucketsResource.error()?.message">
                <nz-select nzRequired nzPlaceHolder="Select Bucket" formControlName="bucket" id="bucket" name="bucket"
                    nzShowSearch [nzLoading]="bucketsResource.isLoading()"
                    [nzDisabled]="bucketsResource.isLoading() || bucketsResource.error()">
                    @if(bucketsResource.hasValue()){
                    @for(bucket of bucketsResource.value(); track bucket.name){
                    <nz-option [nzLabel]="bucket.name" [nzValue]="bucket.name"></nz-option>
                    }
                    }
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item style="flex: 1;">
            <nz-form-label nzRequired>Prefix</nz-form-label>
            <nz-form-control nzErrorTip="Ensure that the prefix ends with / and is non empty">
                <input type="text" nz-input nzRequired placeholder="Enter Valid value" formControlName="prefix"
                    id="prefix" name="prefix">
            </nz-form-control>
        </nz-form-item>

        <nz-space-compact>
            <button style="flex-shrink: 0;" nz-button type="submit" nzType="primary"
                [disabled]="prefixForm.invalid">Fetch</button>
            <button nz-button type="button"><nz-icon nzType="link" (click)="copyLink()" /></button>
        </nz-space-compact>
    </form>

    <nz-divider style="margin: 10px 0px; padding: 0px" />

    <div style="display: flex; justify-content: space-between;">
        <nz-space>
            <button nzType="primary" nz-button [nzLoading]="isApplying()" (click)="markSelectedFor('DEEP_ARCHIVE')">Mark
                for Deep
                Archive</button>
            <button nzType="primary" nz-button [nzLoading]="isApplying()" (click)="markSelectedFor('GLACIER_IR')">Mark
                for Glacier
                Instant Retrieval</button>
            <button nzType="primary" nz-button [nzLoading]="isApplying()" (click)="openRestorationModal()">Mark for
                Restoration</button>
        </nz-space>
        <!-- <button nz-button disabled>Delete</button> -->
        <div style="display: flex; gap: 8px; align-items: center;">
            <button nzType="dashed" nz-button (click)="checkIfOnDashboard()">Check if on dashboard</button>
            <!-- <button nz-button nz-dropdown [nzDropdownMenu]="toolsMenu" nzTrigger="click" nzPlacement="bottomRight">
                <nz-icon nzType="more" nzTheme="outline" />
            </button> -->
            <a nz-dropdown [nzDropdownMenu]="toolsMenu">
                <nz-icon nzType="more" nzTheme="outline" />
            </a>
        </div>

        <nz-dropdown-menu #toolsMenu="nzDropdownMenu">
            <ul nz-menu>
                <li nz-menu-item (click)="copySelection()">Copy selected keys</li>
                <li nz-menu-item (click)="copySelection(true)">Copy selected keys with info</li>
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="calculateSelectedSizes()">Calculate size of selected</li>
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="selectNotOnDashboard()">Select all not on dashboard</li>
                <li nz-menu-item (click)="uncheckAll()">Uncheck all</li>
            </ul>
        </nz-dropdown-menu>
    </div>

    <nz-divider style="margin: 10px 0px; padding: 0px" />

    @if (isEvaluating()) {
    <nz-alert nzType="info" [nzDescription]="descriptionTpl" [nzAction]="actionTpl" />
    <ng-template #descriptionTpl>
        <nz-icon nzType="loading" style="margin-right: 10px;" />
        Listing objects…
    </ng-template>
    <ng-template #actionTpl>
        <button nz-button nzSize="small" (click)="cancelPromises()">Cancel</button>
    </ng-template>
    }

    <div style="overflow: auto;">
        <!-- nzCheckStrictly: a checked folder is submitted as a prefix and expanded server
             side, so ticking its descendants is work the operation never reads. It is also
             quadratic in ng-zorro — conductDown does a linear scan of the checked list per
             node — which locks the tab up on a large tree. -->
        <nz-tree #tree [nzData]="treeNodes()" nzCheckable nzCheckStrictly [nzTreeTemplate]="nodeTemplate" nzBlockNode
            (nzExpandChange)="nzEvent($event)" (nzContextMenu)="onContextMenu($event)" nzAsyncData
            [nzVirtualHeight]="'600px'" [nzVirtualItemSize]="22" />

        <nz-dropdown-menu #nodeMenu="nzDropdownMenu">
            <ul nz-menu>
                <li nz-menu-item (click)="startWalk(true)">Expand all</li>
                <li nz-menu-item (click)="startWalk(false)">Calculate size</li>
                <li nz-menu-item (click)="selectChildren()">Select children</li>
                <li nz-menu-item (click)="navigateToHere()">Navigate</li>
            </ul>
        </nz-dropdown-menu>
        <ng-template #nodeTemplate let-node let-origin="origin">
            <div class="node-row">
                <span class="node-label" [class.is-folder]="!node.isLeaf">
                    <nz-icon [nzType]="node.isLeaf ? 'file' : (node.isExpanded ? 'folder-open' : 'folder')"
                        [nzTheme]="node.isLeaf ? 'outline' : 'twotone'" />
                    {{ node.title }}
                </span>

                <span class="node-meta">
                    @if (node.isLeaf || origin.size != null) {
                    <span class="node-size" nz-typography nzType="secondary">{{ origin.size | formatBytes }}</span>
                    }

                    @if (node.isLeaf) {
                    @let restored = origin.restore_state === 'restored';
                    <nz-tag [nzColor]="restored ? 'success' : classColor[origin.storage_class]">
                        {{ classLabel[restored ? 'STANDARD' : origin.storage_class] }}
                    </nz-tag>

                    @if (origin.restore_state === 'restoring') {
                    <nz-badge nzStatus="processing" nzText="Restoring" />
                    } @else if (restored) {
                    <nz-tag nzColor="warning" [nzBordered]="false" nz-tooltip
                        [nzTooltipTitle]="'Restored copy available until ' + (origin.available_until | date:'mediumDate')">
                        <nz-icon nzType="clock-circle" /><span>{{ origin.hours_left }}h left</span>
                    </nz-tag>
                    }
                    }

                    @if (!node.isLeaf && origin.isOnDashboard !== undefined) {
                    <nz-tag [nzColor]="origin.isOnDashboard ? 'success' : 'error'">
                        <nz-icon [nzType]="origin.isOnDashboard ? 'check-circle' : 'exclamation-circle'" />
                        <span>{{ origin.isOnDashboard ? 'On dashboard' : 'Not on dashboard' }}</span>
                    </nz-tag>
                    }
                </span>
            </div>
        </ng-template>
    </div>

    <app-storage-class-confirm [(target)]="pendingTarget" [selection]="checkedNodes()"
        [bucket]="prefixForm.controls.bucket.value ?? ''" (confirmed)="applyStorageClass($event)" />
</div>